export default __webpack_public_path__ + "static/media/usscg_logo.3bf707e5.svg";